import React from "react";
import "../question/Question.css";
import parse from "html-react-parser";
import LatexProcessorComponent from "../../../../utils/LatexProcessorComponent";

export default function Rtypepara(props) {
  const { index } = props;

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }

  const EsplitLines = props.list.split("\n");

  return (
    <div className=" Question_temp_VQ pt-0 pb-0">
      <div className="row mt-2">
        <div className="col-md-12 p-0">
          <span className={props.classET}>
            {/* parse()  */}
            {EsplitLines.length > 0 ? (
              <LatexProcessorComponent originalString={EsplitLines[0]} />
            ) : (
              ""
            )}
          </span>
        </div>
        {EsplitLines.map((line, index) => {
          if (line.startsWith("p1-")) {
            return (
              <div className="col-md-12" key={index}>
                <p className={props.classET}>
                  <LatexProcessorComponent originalString={line.substring(4)} />
                  {/* {parse(line.substring(4))} */}
                </p>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
}
